<template>
    <svg
        v-if="direction == 'up' || direction == 'down'"
        v-bind="$attrs"
        xmlns="http://www.w3.org/2000/svg"
        v viewBox="0 0 10 32"
        class="icon-svg icon-arrow-long"
        :class="[color ? color : '', size ? 'icon--size-' + size : '', direction ? 'icon--direction-' + direction : '']"
    >
        <path d="M10 5.12L9.125 6.016L5.625 2.432L5.625 32L4.375 32L4.375 2.432L0.874999 6.016L-6.08787e-07 5.12L5 6.66161e-07L10 5.12Z" />

    </svg>
    <svg
        v-else
        v-bind="$attrs"
        xmlns="http://www.w3.org/2000/svg"
        width="50" height="16" viewBox="0 0 50 16"
        class="icon-svg icon-arrow-long"
        :class="[color ? color : '', size ? 'icon--size-' + size : '', direction ? 'icon--direction-' + direction : '']"
    >
        <path d="M8 16L9.4 14.6L3.8 9L50 9L50 7L3.8 7L9.4 1.4L8 -3.67176e-06L6.99382e-07 8L8 16Z" />
    </svg>
</template>

<script>
export default {
    props: {
        color: { type: String, default: "" },
        size: { type: String, default: "default" },
        direction: { type: String, default: "left" },
    },
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
// Direction
.icon--direction {
    &-right,
    &-down {
        transform: rotate(180deg);
    }
    &-left,
    &-right {
        // Size
        &.icon--size {
            &-xx-small {
                width: 20px !important;
            }
            &-x-small {
                width: 24px !important;
            }
            &-small {
                width: 28px !important;
            }
            &-default {
                width: 32px !important;
            }
            &-large {
                width: 50px !important;
            }
            &-x-large {
                width: 54px !important;
            }
            &-xx-large {
                width: 58px !important;
            }
        }
    }
    &-up,
    &-down {
        // Size
        &.icon--size {
            &-xx-small {
                height: 20px !important;
            }
            &-x-small {
                height: 24px !important;
            }
            &-small {
                height: 28px !important;
            }
            &-default {
                height: 32px !important;
            }
            &-large {
                height: 50px !important;
            }
            &-x-large {
                height: 54px !important;
            }
            &-xx-large {
                height: 58px !important;
            }
        }
    }
}
@media (min-width:576px){
}
@media (min-width:768px){
    .icon--direction {
        &-right,
        &-down {
            transform: rotate(180deg);
        }
        &-left,
        &-right {
            // Size
            &.icon--size {
                &-xx-small {
                    width: 24px !important;
                }
                &-x-small {
                    width: 28px !important;
                }
                &-small {
                    width: 32px !important;
                }
                &-default {
                    width: 50px !important;
                }
                &-large {
                    width: 54px !important;
                }
                &-x-large {
                    width: 58px !important;
                }
                &-xx-large {
                    width: 62px !important;
                }
            }
        }
        &-up,
        &-down {
            // Size
            &.icon--size {
                &-xx-small {
                    height: 24px !important;
                }
                &-x-small {
                    height: 28px !important;
                }
                &-small {
                    height: 32px !important;
                }
                &-default {
                    height: 50px !important;
                }
                &-large {
                    height: 54px !important;
                }
                &-x-large {
                    height: 58px !important;
                }
                &-xx-large {
                    height: 62px !important;
                }
            }
        }
    }
}
@media (min-width:1024px){
}
@media (min-width:1200px){
}

</style>
